var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Styles from './take-quiz-styles.scss';
import { ButtonKVBase, CircleResult } from '@/presentation/components';
import { useNavigate, useParams } from 'react-router';
import { quizState } from './components/atoms';
import { useRecoilState, useResetRecoilState } from 'recoil';
import QuestionResult from '@/presentation/components/quiz/question-result';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request';
import { lessonState } from '../lessons/components/atoms';
import { orderArrayByOrden } from '@/presentation/utils/order-utils';
import Warning4 from '@/presentation/components/icons/warning4';
import useRouterQuery from '@/presentation/hooks/use-router-query';
import HeaderMenu from '../manage-module/components/header-menu';
const TakeQuiz = ({ manageQuizzes, manageQuizzesUsers, manageProgressService, loadLessons, manageUsers }) => {
    var _a, _b, _c, _d, _e;
    const [state, setState] = useRecoilState(quizState);
    const resetState = useResetRecoilState(quizState);
    const [_, setStateLesson] = useRecoilState(lessonState);
    const navigate = useNavigate();
    let { idQuiz, id, idLesson } = useParams();
    const { user } = useUserSesssion();
    const query = useRouterQuery();
    const idModule = query.get('idModule');
    const idLessons = query.get('idLesson');
    idLesson = idLesson || parseInt(idLesson) > 0 ? idLesson : idLessons;
    const { showCustomError } = useCustomToast({
        containerId: 'main-dashboard-container'
    });
    const continueQuiz = () => {
        setStateLesson(prev => (Object.assign(Object.assign({}, prev), { reloadItems: !prev.reloadItems })));
        navigate(`/student-dashboard/my-modules/${idModule}/lessons/${idLesson}/quiz`);
    };
    const getData = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const qb0 = RequestQueryBuilder.create();
            qb0.setJoin({ field: 'questions' });
            qb0.setJoin({ field: 'questions.answers' });
            qb0.setJoin({ field: 'questions.type' });
            const data = yield manageQuizzes.findOne({ id: parseInt(idQuiz), queryBuilder: qb0 });
            if (data)
                setState(prev => (Object.assign(Object.assign({}, prev), { data })));
            const qb = RequestQueryBuilder.create();
            qb.setFilter({ field: 'userId', operator: CondOperator.EQUALS, value: id && id !== '' ? parseInt(id) : user.id });
            qb.setFilter({ field: 'quizzesId', operator: CondOperator.EQUALS, value: idQuiz });
            qb.setFilter({ field: 'lessonId', operator: CondOperator.EQUALS, value: idLesson });
            const dataUserResults = yield manageQuizzesUsers.find({ queryBuilder: qb });
            console.log('===>', dataUserResults.length);
            if (dataUserResults.length > 0) {
                const dataUserResult = dataUserResults[0];
                setState(prev => (Object.assign(Object.assign({}, prev), { answers: dataUserResult.answers, percent: dataUserResult === null || dataUserResult === void 0 ? void 0 : dataUserResult.percentResult, correctAnswers: dataUserResult.correctAnswers, checkResults: true, isLoading: false, attempts: dataUserResult.attempts, currentAttempt: dataUserResult, totalQuestionsAnswered: dataUserResult.totalQuestions })));
            }
            else {
                setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: false })));
            }
        }
        catch (error) {
            showCustomError('Error', error.message);
        }
    });
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        yield resetState();
        yield getData();
    });
    useEffect(() => {
        if (idQuiz)
            init();
    }, [idQuiz]);
    return (React.createElement("div", { className: ((_a = user === null || user === void 0 ? void 0 : user.role) === null || _a === void 0 ? void 0 : _a.description) === 'Student' ? Styles.mainWrapOriginal : Styles.mainWrap },
        React.createElement(Container, { className: "d-flex flex-column align-items-center", style: { width: '57.5vw' } },
            React.createElement("div", { className: "w-100" },
                React.createElement(HeaderMenu, { title1: "Take Quiz", title2: state.checkResults ? 'Results' : 'Instructions', onBack: () => navigate(user.role.description === 'Student'
                        ? `/student-dashboard/my-modules/${idModule}/lessons/${idLesson}/quiz`
                        : `/`) })),
            React.createElement("div", { className: Styles.titleCard },
                React.createElement("div", null, !state.checkResults ? (React.createElement("img", { className: Styles.titleImg })) : (React.createElement(CircleResult, { percent: state === null || state === void 0 ? void 0 : state.percent, questions: state.totalQuestionsAnswered, correctAnswers: state === null || state === void 0 ? void 0 : state.correctAnswers }))),
                React.createElement("div", { className: "text-center" },
                    React.createElement("div", { className: Styles.title }, (_b = state.data) === null || _b === void 0 ? void 0 : _b.name),
                    React.createElement("div", { className: Styles.subtitle }, (_c = state.data) === null || _c === void 0 ? void 0 : _c.description)),
                React.createElement("div", null,
                    React.createElement("span", { className: Styles.headerT1 }, "Earn KV bucks for each correct answer."),
                    React.createElement("span", { className: Styles.headerT2 },
                        "1st attempt: ",
                        React.createElement("span", null, "$1,000 KV")),
                    React.createElement("span", { className: Styles.headerT3 },
                        "2nd attempt: ",
                        React.createElement("span", null, "$500 KV"))),
                !state.checkResults && (React.createElement("div", { className: "w-90" },
                    React.createElement("div", { className: Styles.quizRulesWrap },
                        React.createElement("div", { className: Styles.icon },
                            React.createElement(Warning4, null)),
                        React.createElement("div", { className: Styles.rules },
                            React.createElement("div", { className: Styles.rBody },
                                React.createElement("b", null, "Quiz Rules:"),
                                React.createElement("ul", null,
                                    React.createElement("li", null, "Answer each question before time\u2019s up!"),
                                    React.createElement("li", null, "You\u2019ve got 60 seconds per question\u2014use \u2018em wisely"),
                                    React.createElement("li", null, "If time runs out, it\u2019s an automatic incorrect answer."),
                                    React.createElement("li", null, "Want a second shot? You can retake the quiz to boost your score, but you\u2019ll earn fewer KV Bucks per question."))))),
                    React.createElement("br", null),
                    React.createElement(ButtonKVBase, { type: "button", onClick: () => navigate(`/student-dashboard/take-quizv2/${idQuiz}?idModule=${idModule}&idLesson=${idLesson}`), btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", loading: state.isLoading }, "Start Quiz")))),
            state.checkResults && (React.createElement("div", { className: Styles.bodyCard },
                React.createElement("div", { className: "d-flex align-items-center justify-content-between" },
                    React.createElement("div", { className: Styles.title }, "Questions"),
                    React.createElement("div", null,
                        React.createElement("span", { className: Styles.text2 }, "Current attempt:"),
                        (state === null || state === void 0 ? void 0 : state.attempts) === 1 ? (React.createElement("span", { className: Styles.headerT4 }, "1st")) : (React.createElement("span", { className: Styles.headerT5 }, "2nd")))), (_e = orderArrayByOrden((_d = state.data) === null || _d === void 0 ? void 0 : _d.questions)) === null || _e === void 0 ? void 0 :
                _e.map((item, key) => (React.createElement(QuestionResult, { key: `${item.id}_${key}`, question: item, answers: state.answers, showCorrectAnswers: true }))),
                React.createElement("hr", null),
                id === '' ||
                    id === 'undefined' ||
                    id === 'null' ||
                    (!id && (React.createElement(ButtonKVBase, { type: "button", onClick: continueQuiz, btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", loading: state.isLoading }, "Continue"))))),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null))));
};
export default TakeQuiz;
